import React from 'react';
import { GridList, GridListTile, GridListTileBar, Tooltip, IconButton } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import {withStyles} from '@material-ui/core/styles';
import styles from './ModelContainer.css';
import classNames from 'classnames';
import models from '../../../models';

function ModelContainer(props) {

    const {classes} = props;
        return (
            <div className={classes.ModelContainer}>
                {/* <div className={classes.header3}>
                    <Typography variant="h6" align="center" className={classes.header3}>
                        Step 2: Select your model
                    </Typography>
                </div> */}
                <div 
                // className={classes.modelGridList}
                >
                    <GridList cols={models.length} classes={{root: classes.modelGridList}} cellHeight='auto'>
                        {models.map( (tile, index) => (
                            <Tooltip key={index} title={tile.description} placement="top">
                                <GridListTile 
                                    key={index} 
                                    className={
                                        classNames(
                                            // classes.selectableModel, 
                                            index===props.selectedModel
                                                ? classes.selectedModel
                                                : null
                                        )
                                    }
                                    classes={{root: classes.selectableModel}}
                                    onClick={props.editable ? ()=>props.setSelectedModel(index):null}
                                >
                                    <div className={classes.modelImageContainer}>
                                        <img 
                                            src={process.env.PUBLIC_URL + tile.logo} 
                                            alt={tile.name}
                                            className={classNames(classes.modelImage, classes.activeImage)}
                                        />
                                        <img 
                                            src={process.env.PUBLIC_URL + tile.animation} 
                                            alt={tile.name}
                                            className={classes.modelImage}
                                        />
                                    </div>
                                        
                                    <GridListTileBar
                                        title={tile.name}
                                        actionIcon={
                                            <IconButton className={classes.icon} onClick={props.displayModelInfo}>
                                                <InfoIcon />
                                            </IconButton>
                                        }
                                    />
                                </GridListTile>
                            </Tooltip>
                        ))}
                    </GridList>                
                </div>

                {/* <Button variant="contained" color="primary" onClick={this.onUploadAndSubmit} disabled={!submitAllowed}>
                    SUBMIT <CloudUploadIcon className={classes.rightIcon} />
                </Button> */}

                {/* <ModelInfoDialog
                    open={this.props.modelInfoOpen}
                >
                </ModelInfoDialog> */}
            </div>
        );
}

export default withStyles(styles, {withTheme: true})(ModelContainer);
